import { render } from "./VehicleOneCCard.vue?vue&type=template&id=1abf91aa"
import script from "./VehicleOneCCard.vue?vue&type=script&lang=js"
export * from "./VehicleOneCCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__